// removed by extract-text-webpack-plugin
module.exports = {"root":"page-title--root--39Vkwfnl","root-home":"page-title--root-home--1PXsYQy8","rootHome":"page-title--root-home--1PXsYQy8","title-container":"page-title--title-container--A9vuusP_","titleContainer":"page-title--title-container--A9vuusP_","page-title":"page-title--page-title--2ddiMwg3","pageTitle":"page-title--page-title--2ddiMwg3","title":"page-title--title--3c51MkgN","action":"page-title--action--dhnw0Aid"};


//////////////////
// WEBPACK FOOTER
// ./components/page-title/styles.css
// module id = ./components/page-title/styles.css
// module chunks = 0